import { makeAutoObservable } from "mobx";
import { RootStore } from "../Store";
import { WorkSubmissionStore } from "./WorkSubmissionStore";
import { ActivitiesStore } from "./ActivitiesStore";

export class EngToolStore {
  rootStore: RootStore;

  workSubmissions: WorkSubmissionStore;
  activities: ActivitiesStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
    this.rootStore = rootStore;
    this.workSubmissions = new WorkSubmissionStore(this);
    this.activities = new ActivitiesStore(this);
  }
}
